import React from 'react'
import '../../Explorer/dox_explorer.scss'
import { useTranslationContext } from '../../Shared/hooks/useTranslationContextHook'
import BlockSignalLink from '../../../../../../../src/components/library/common/BlockSignalLink'
import HrbTranslate from '../../../../../../components/language/HrbTranslate'

const DoxUploadFailMessage = () => {
    const translateString = useTranslationContext()

    return (
        <div className='doxe-msg-outer'>
            <div className='dox-upload-success-msg'>
                <h1>{translateString('Dox.DocumentUploader.FailMessage.Title1')}</h1>
                <h1 className='fail-message-subtitle mb-4'>{translateString('Dox.DocumentUploader.FailMessage.Title2')}</h1>
                <div className='upload-fail-text mb-2'>{translateString('Dox.DocumentUploader.FailMessage.Message1')}</div>
                <div className='upload-fail-text mb-2'>{translateString('Dox.DocumentUploader.FailMessage.Message2')}</div>
                <HrbTranslate text="Dox.DocumentUploader.FailMessage.BlockSignalMessage" params={{ BlockSignal: <BlockSignalLink /> }} className='upload-fail-text mb-2' />
                <div className='upload-fail-text mb-2'>{translateString('Dox.DocumentUploader.FailMessage.IncludeInfo')}</div>
                <div className='upload-fail-text mb-2'>{translateString('Dox.DocumentUploader.FailMessage.DescribeIssue')}</div>
            </div>
        </div>
    )
}

export default DoxUploadFailMessage;